import React from 'react';
import { Box, BoxProps } from '@mui/material';

export { BoxProps as CardProps };
export default function Card(props: BoxProps) {
  let { sx, ...others } = props;
  sx = {
    backgroundColor: '#FFFFFF',
    border: '1px solid rgba(238, 234, 248, 0.75)',
    boxSizing: 'border-box',
    boxShadow: '0px 5px 40px -11.4039px rgba(229, 233, 242, 0.3)',
    borderRadius: '18px',
    ...(sx || {}),
  };

  return <Box sx={sx} {...others} />;
}
